export const getColorMappings = (sidenavColor) => {
  let barColor;
  let tableBorder;

  if (sidenavColor === "primary") {
    barColor = "linear-gradient(195deg, #EC407A, #D81B60)";
    tableBorder = "#D81B60";
  } else if (sidenavColor === "dark") {
    barColor = "linear-gradient(195deg, #42424a, #191919)";
    tableBorder = "#191919";
  } else if (sidenavColor === "info") {
    barColor = "linear-gradient(195deg, #3198e7, #1ed6ca)";
    // tableBorder = "#1A73E8";
    // barColor = "#1ed6c9";
    tableBorder = "#1ed6ca";
  } else if (sidenavColor === "success") {
    barColor = "linear-gradient(195deg, #66BB6A, #43A047)";
    tableBorder = "#43A047";
  } else if (sidenavColor === "warning") {
    barColor = "linear-gradient(195deg, #FFA726, #FB8C00)";
    tableBorder = "#FB8C00";
  } else if (sidenavColor === "error") {
    barColor = "linear-gradient(195deg, #EF5350, #E53935)";
    tableBorder = "#E53935";
  } else {
    barColor = "linear-gradient(195deg, #EC407A, #D81B60)";
    tableBorder = "#D81B60";
  }

  return { barColor, tableBorder };
};
